module.exports = __webpack_public_path__ + "static/icons-03b58a7f4f1f96e2d309ce788a8504c3.png";